@if (currentMode === FieldMode.READ && !isCreatingEntity) {
  <div class="read-field-container">
    <div [hidden]="!viewToggled"
         [ngClass]="{'no-value': !accessManager.hasAllNeededPermissions(permissionsForEdition) || !preconditionsForEdition}"
         class="field-row fx-layout-row fx-wrap fx-justify-start fx-align-baseline">
      <div class="field-label fx-flex-100-33-percent">
        {{ fieldConfig.label }}
        @if (fieldConfig.tooltip) {
          <span #tooltip="matTooltip" [matTooltip]="fieldConfig.tooltip"
                matTooltipPosition="below" (click)="onClickTooltip(tooltip)">
            <mat-icon fontSet="mdi" fontIcon="mdi-help-circle" class="tooltip-icon"></mat-icon>
          </span>
        }
      </div>
      @if (isSingleRelatedAsset) {
        <div class="field-container clickable-field fx-flex-100-66-percent fx-layout-col">
          <div (click)="onActivate($event)" (keyup.enter)="onActivate($event)" tabindex="0"
               [ngClass]="{'read-value': accessManager.hasAllNeededPermissions(permissionsForEdition) && preconditionsForEdition,
                        'computed': !(accessManager.hasAllNeededPermissions(permissionsForEdition) && preconditionsForEdition)}">
            <a (click)="navigateToEntitySheet()">
              {{ getFieldValue() | emptyFieldPipe: {blankFieldValue: appConfig.EMPTY_FIELD_VALUE} }}
            </a>
            @if (accessManager.hasAllNeededPermissions(permissionsForEdition)) {
              <span
                class="overlay-icon">
                @if (preconditionsForEdition) {
                  <mat-icon fontSet="mdi" fontIcon="mdi-pencil" class="selectable"></mat-icon>
                } @else {
                  <mat-icon fontSet="mdi" fontIcon="mdi-pencil-off" [matTooltipPosition]="'below'" [matTooltip]="'TOOLTIP.READ_ONLY_VALUE' | translate" class="tooltip-icon"></mat-icon>
                }
              </span>
            }
          </div>
        </div>
      } @else {
        <div class="field-container fx-flex-100-66-percent fx-layout-col">
          <div (click)="onActivate($event)" (keyup.enter)="onActivate($event)" tabindex="0"
               [ngClass]="{'read-value':accessManager.hasAllNeededPermissions(permissionsForEdition) && preconditionsForEdition}">
            @if (getFieldValue()?.length > 0) {
              <mat-chip-listbox tabIndex="-1">
                @for (chip of (getFieldValue()| slice:0:5); track chip.id) {
                  <mat-chip-option class="clickable-field" (click)="onActivate($event)"
                    (keyup.enter)="onActivate($event)"
                    >
                    <a (click)="navigateToAssetDashboardByAssetId(chip.id)">
                      {{ chip?.toString() }}
                    </a>
                  </mat-chip-option>
                }
                @if (getFieldValue()?.length > 5) {
                  {{ 'TOOLTIP.AND_MORE' | translate: {quantity: (getFieldValue().length - 5)} }}
                }
              </mat-chip-listbox>
            } @else {
              <span>{{ appConfig.EMPTY_FIELD_VALUE }}</span>
            }
            @if (accessManager.hasAllNeededPermissions(permissionsForEdition)) {
              <span
                class="overlay-icon">
                @if (preconditionsForEdition) {
                  <mat-icon fontSet="mdi" fontIcon="mdi-pencil" class="selectable"></mat-icon>
                } @else {
                  <mat-icon fontSet="mdi" fontIcon="mdi-pencil-off" [matTooltipPosition]="'below'" [matTooltip]="'TOOLTIP.READ_ONLY_VALUE' | translate" class="tooltip-icon"></mat-icon>
                }
              </span>
            }
          </div>
        </div>
      }
    </div>
  </div>
}

@if (currentMode === FieldMode.EDIT || isCreatingEntity) {
  <div>
    <div [hidden]="!editToggled || !viewToggled"
         class="field-row fx-layout-row fx-wrap fx-justify-start fx-align-baseline">
      @if (!isCreatingEntity) {
        <div class="field-label fx-flex-100-33-percent">
          {{ fieldConfig.label }}
          @if (fieldConfig.tooltip) {
            <span #tooltip="matTooltip" [matTooltip]="fieldConfig.tooltip"
                  (click)="onClickTooltip(tooltip)">
              <mat-icon fontSet="mdi" fontIcon="mdi-help-circle" class="tooltip-icon"></mat-icon>
            </span>
          }
        </div>
      }
      <div class="field-container fx-flex-100-66-percent fx-layout-col">
        <mat-form-field appearance="outline">
          <mat-label>{{'LABEL.ASSET' | translate}}</mat-label>
          <mat-select-asset-autocomplete #inputField [formControl]="form.controls.field"
                                         [required]="fieldConfig.customOptions?.required"
                                         [disabled]="(asyncPreconditionsForEdition$ | async) === false">
          </mat-select-asset-autocomplete>
        </mat-form-field>
        @if (isSingleField) {
          <div class="save-options">
            <button (click)="onClickCancel()" (keyup.escape)="onEscapeCancel($event)" class="button">
              <mat-icon fontSet="mdi" fontIcon="mdi-close"></mat-icon>
            </button>
            <button (click)="onClickSave()" (keyup.escape)="onEscapeCancel($event)" [disabled]="!form.valid"
                    class="button save">
              <mat-icon fontSet="mdi" fontIcon="mdi-check"></mat-icon>
            </button>
          </div>
        }
      </div>
    </div>
  </div>
}

